import React, { PropsWithChildren } from 'react';

import styles from './Navigation.module.scss';

function Navigation({ children }: PropsWithChildren) {
  return <nav className={styles.navigation}>{children}</nav>;
}

export default Navigation;
